import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './languages/tr';
import en from './languages/en';
import fr from './languages/fr';
import ar from './languages/ar';
import ekler from './ekler';

const savedLang = localStorage.getItem('lang') || 'tr';
document.documentElement.lang = savedLang;
document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';

// Ek metinler ana dil dosyalarıyla derin birleştirilir (aynı anahtarda ek kazanır)
const birlestir = (hedef, kaynak) => {
  const sonuc = { ...hedef };
  for (const [k, v] of Object.entries(kaynak || {})) {
    sonuc[k] = v && typeof v === 'object' && !Array.isArray(v) ? birlestir(hedef?.[k] || {}, v) : v;
  }
  return sonuc;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: birlestir(tr, ekler.tr) },
      en: { translation: birlestir(en, ekler.en) },
      fr: { translation: birlestir(fr, ekler.fr) },
      ar: { translation: birlestir(ar, ekler.ar) },
    },
    lng: savedLang,
    fallbackLng: 'tr',
    interpolation: { escapeValue: false },
  });

export default i18n;
